import  { useEffect, useRef, useState } from 'react';
import {Button, Card,  Col, DatePicker, Form, Input, Modal, Popconfirm, Radio, Row, Select, Space, Table, Tooltip} from 'antd'
import './pages-finance-collections.css';
import {FormOutlined, SearchOutlined ,IssuesCloseOutlined} from '@ant-design/icons';
import Highlighter from 'react-highlight-words';
import moment from 'moment';
import TextArea from 'antd/lib/input/TextArea';
import { CollectionPaymentTypes, TransactionPaymentType, TransactionStatus, TransactionType } from '@gtpl/shared-models/common-models';
import {CollectionsService, PurchasesProductService} from 'libs/shared-services/finance/src'
import { CollectionsReq, PaymentTypeReq } from 'libs/shared-models/finance/src';
import { AlertMessages } from '@gtpl/shared-utils/alert-messages';
import React from 'react';
import DDBCollections from './DDB-collection';
import { Link } from 'react-router-dom';
// import Link from 'antd/lib/typography/Link';
import Rodtep from './rodtep-collection';
import IgstCollections from './igst-collections';
import {  BankDetailsService } from '@gtpl/shared-services/masters';
import {  SaleOrderService } from '@gtpl/shared-services/sale-management';

/* eslint-disable-next-line */
export interface CollectionsProps {
  tab:string
}

export function Collections(props: CollectionsProps) {
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState<number>(100);
  const [data, setData] = useState([])
  const [searchText, setSearchText] = useState("");
  const [searchedColumn, setSearchedColumn] = useState("");
  const searchInput = useRef(null);
  const [isModalVisible,setIsModalVisible] = useState<boolean>(false)
  const [acceptButton,setAcceptButton] = useState<boolean>(false)
  const [collapse,SetCollapse] = useState<boolean>(false)
  const { Option } = Select;
  const [form] = Form.useForm();
  const [form1] = Form.useForm();
  const service = new CollectionsService()
  const [soData, setSoData] = useState<any>()
  const [form2] = Form.useForm();
  const [tab, setTab] = useState("");
  const [ddb,setDdb] = useState(false)
  const [rodtep,setRodtep] = useState(false)
  const [igst,setIgst] = useState(false)
  const [advance,setAdvance] = useState()
  const [showFinancialYear, setShowFinancialYear] = useState(false);
  const [exportReceivables,setExportReceivables] = useState(false)
  const [buyers, setBuyers] = useState([])
  const [amt, setAmt] = useState("");
  const [advanceMap, setAdvanceMap] = useState(new Map())
  const[bankDetails,setBankDetails] = useState<any[]>([])
  const bankDetailsService = new BankDetailsService()
const [years,setYears] = useState<any[]>([])
  const invoiceDataService = new SaleOrderService;
    const [factoriesData, setFactoriesData] = useState([]);
    const purchaseService = new PurchasesProductService()
  useEffect(() => {
    console.log(igst,'ooooooooooo');
    
    console.log(tab,advance);
    console.log(form.getFieldValue('paymentType'))
    // if (advance ) {
      // form.setFieldsValue({
      //   paymentType: TransactionPaymentType.Part_Payment,
      //   transactionStatus: TransactionStatus.OPEN,
      // });
    // }
    getBuyers(tab)
    getAllFinancialYear()
    getBankDetails()
    getAllCompanyNames()
}, [tab,advance])
const getBuyers = (tab) => {
  const req = new PaymentTypeReq(tab)
    service.getBuyers(req).then((res)=>{
    if(res.status){
    setBuyers(res.data)
    }
  })
}

    const getAllCompanyNames = () => {
    purchaseService.getAllCompanys().then((res) => {
        if (res.status) {
            setFactoriesData(res.data)
        }
    })
}


const getAllFinancialYear  = () => {
  invoiceDataService.getAllFinancialYear().then(res => {
    if (res.status) {
      setYears(res.data);
    } else {
      if (res.intlCode) {
        setYears([]);
        AlertMessages.getErrorMessage(res.internalMessage);
      } else {
        AlertMessages.getErrorMessage(res.internalMessage);
      }
    }
  }).catch(err => {
    setYears([]);
    AlertMessages.getErrorMessage(err.message);
  })
}
const getBankDetails = () => {
  bankDetailsService.getAllBankDetailsInfo().then(res=>{
    if(res.status){
      setBankDetails(res.data)
    }
  })
}

  const getData = (tab,advanceVal) => {
    const req = new PaymentTypeReq(tab)
    if(form2.getFieldValue('buyer') !== undefined){ 
      req.buyer = form2.getFieldValue('buyer')
    }
    if(form2.getFieldValue('financialYear') !== undefined){
      req.financeYear = form2.getFieldValue('financialYear')
    }
     if(form2.getFieldValue('unit') !== undefined){
      req.unitId = form2.getFieldValue('unit')
    }
    req.advance = advanceVal
    
    service.getCollection(req).then((res)=>{
      if (res.status) {
      setData(res.data); 
    } else {
      setData([]);       
    }
  }).catch((err) => {
    console.error('Error fetching data:', err);
    setData([]);
  });
}


  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };
  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText("");
  };

  ;
  const getColumnSearchProps = (dataIndex: string) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={searchInput}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ width: 188, marginBottom: 8, display: "block" }}
        />
        <Button
          type="primary"
          onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
          icon={<SearchOutlined />}
          size="small"
          style={{ width: 90, marginRight: 8 }}
        >
          Search
        </Button>
        <Button
          size="small"
          style={{ width: 90 }}
          onClick={() => {
            handleReset(clearFilters);
            setSearchedColumn(dataIndex);
            confirm({ closeDropdown: true });
          }}
        >
          Reset
        </Button>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined
        type="search"
        style={{ color: filtered ? "#1890ff" : undefined }}
      />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        ? record[dataIndex]
          .toString()
          .toLowerCase()
          .includes(value.toLowerCase())
        : false,
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current.select());
      }
    },
    render: (text) =>
      text ? (
        searchedColumn === dataIndex ? (
          <Highlighter
            highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
            searchWords={[searchText]}
            autoEscape
            textToHighlight={text.toString()}
          />
        ) : (
          text
        )
      ) : null,
  });
const payment =(val) =>{
  const newMap = new Map(advanceMap);
  newMap.set(val.invoiceNumber, true); // Identify by a unique field like invoiceNumber
  setAdvanceMap(newMap)
  // if (advance ) {
  //   console.log(advance);
  //   form.setFieldsValue({
  //     paymentType: TransactionPaymentType.Part_Payment,
  //     transactionStatus: TransactionStatus.OPEN,
  //   });
  // }
setAmt(val.totalAmount)
setIsModalVisible(true)
setSoData(val)
// setAdvance(advance)
console.log(form.getFieldValue('paymentType')
);

}
const onRadioButtonChange = (e) => {
  console.log(e.target.value)
    if(e.target.value === TransactionPaymentType.Full_Payment){
    form.setFieldsValue({'transactionStatus':TransactionStatus.CLOSE})
  }else{
    form.setFieldsValue({'transactionStatus':TransactionStatus.OPEN})
  }
}
const columns: any[] = [
    {
      title: 'S No', dataIndex: 'sNo', render: (text, object, index) => {
        if (index == data.length) {
          return null;
        } else {
          return index + 1
        }
      },
      width: 60,

    },
    {
       title: 'PO Number', 
      width: 200,
      dataIndex: 'poNum',
      render: (text: any, record: any) => { return record.poNum ? record.poNum : '-' } ,
      sorter: (a, b) => a.poNum.localeCompare(b.poNum),
      sortDirections: ['descend', 'ascend'],
     ...getColumnSearchProps('poNum')},
     ...(!advance? [
      {
       title: 'Invoice Number', 
      width: 200,
      dataIndex: 'invoiceNumber',

        render: (text: any, record: any) => { return record.invoiceNumber ? record.invoiceNumber : '-' } ,
        sorter: (a, b) => a.invoiceNumber.localeCompare(b.invoiceNumber),
      sortDirections: ['descend', 'ascend'],
     ...getColumnSearchProps('invoiceNumber')},
         {
       title: 'Invoice Date', 
      width: 200,
      dataIndex: 'invoiceDate',

 render: (_: any, record: any) => {
    const date = record.invoiceDate;
    return date && moment(date).isValid()
      ? moment(date).format('DD-MM-YYYY')
      : '-';
  },        sorter: (a, b) => a.invoiceDate.localeCompare(b.invoiceDate),
      sortDirections: ['descend', 'ascend'],
     ...getColumnSearchProps('invoiceDate')}
      ]:[]),
    {
       title: 'ETD', 
      width: 200,
      dataIndex: 'etd',

        render: (text: any, record: any) => { return record.etd ? moment(record.etd).format('DD-MM-YYYY') : '-' },
        sorter: (a, b) => a.etd.localeCompare(b.etd),
      sortDirections: ['descend', 'ascend'],
     },
     {
      title: 'ETA', 
     width: 200,
     dataIndex: 'eta',

       render: (text: any, record: any) => { return record.eta ? moment(record.eta).format('DD-MM-YYYY') : '-' },
       sorter: (a, b) => a.eta.localeCompare(b.eta),
     sortDirections: ['descend', 'ascend'],
    },
    {
       title: 'Buyer', 
      width: 200,
      dataIndex: 'buyer',
        render: (text: any, record: any) => { return record.buyer ?  record.buyer : '-' },
        sorter: (a, b) => a.buyer.localeCompare(b.buyer),
      sortDirections: ['descend', 'ascend'],
     },
     {
      title: 'Payment Terms', 
     width: 200,
     dataIndex: 'paymentTerms',
       render: (text: any, record: any) => { return record.paymentTerms ?  record.paymentTerms : '-' },
       sorter: (a, b) => a.paymentTerms.localeCompare(b.paymentTerms),
     sortDirections: ['descend', 'ascend'],
    },
   
    {
       title: 'Bank Name', 
      width: 100,
      dataIndex: 'bankName',

        render: (text: any, record: any) => { return record.bankName ? record.bankName : '-' },
        sorter: (a, b) => a.bankName.localeCompare(b.bankName),
      sortDirections: ['descend', 'ascend'],
    //  ...getColumnSearchProps('qtyStock')
     },
      ...(!advance? [
     {
      title: 'Due Date', 
     width: 200,
     dataIndex: 'dueDate',

       render: (text: any, record: any) => { return record.dueDate ? moment(record.dueDate).format('DD-MM-YYYY') : '-' },
       sorter: (a, b) => a.dueDate.localeCompare(b.dueDate),
     sortDirections: ['descend', 'ascend'],
    },
  ]:[]),
    {
       title: advance?'Total Amount In USD':' INVOICE VALUE IN USD ', 
       dataIndex: 'totalAmount',
       width: 200,

        render: (text: any, record: any) => { return record.totalAmount ? record.totalAmount : '-' },
        sorter: (a, b) => a.totalAmount.localeCompare(b.totalAmount),
      sortDirections: ['descend', 'ascend'],
     ...getColumnSearchProps('totalAmount')
     },
     {
      title: `Action`,
      dataIndex: 'action',
      fixed: 'right',
      render: (text, rowData) => {
      return(<FormOutlined title="Payment" onClick={() => payment(rowData)}/> )
     }
    }

  ]
  let createdUser = ""
  createdUser=JSON.parse(localStorage.getItem("username"));
  // if(!props.isUpdate){
  // }
  // let unitId = localStorage.getItem("unit_id")

const save = (val) =>{
  console.log(val.transactionType == TransactionPaymentType.Full_Payment && soData.totalAmount >= Number(val.receivedAmt)+Number(val.buyerShortPayment?val.buyerShortPayment:0)+Number(val.bankCharges?val.bankCharges:0),'totalAmounttotalAmounttotalAmount');
  
  if(Number(soData.totalAmount) >= Number(Number(val.receivedAmt)+Number(val.buyerShortPayment?val.buyerShortPayment:0)+Number(val.bankCharges?val.bankCharges:0))){
    // console.log(val.transactionType == TransactionPaymentType.Full_Payment,'iiiiiiiiiiiiiiiiiiiiii');
    // console.log( val.transactionType == TransactionPaymentType.Full_Payment &&
    //   Number(soData.totalAmount) == Number(val.receivedAmt) + Number(val.buyerShortPayment ? val.buyerShortPayment : 0) + Number(val.bankCharges ? val.bankCharges : 0)
    // ,'88888888888');
    
    if(val.transactionType == TransactionPaymentType.Full_Payment && Number(soData.totalAmount) === Number(val.receivedAmt)+Number(val.buyerShortPayment?val.buyerShortPayment:0)+Number(val.bankCharges?val.bankCharges:0)
    ){
      // console.log(Number(val.receivedAmt)+Number(val.buyerShortPayment?val.buyerShortPayment:0)+Number(val.bankCharges?val.bankCharges:0),'oooooooooo888888888888888oo');
      const req= new CollectionsReq(Number(val.bankCharges),soData.buyerId,soData.bankId,val.buyerShortPayment,val.dueDate,soData.eta,soData.etd,soData.totalAmount,soData.invoiceNumber?soData.invoiceNumber:null,soData.paymentTermsId,soData.poNum,val.receivedAmt,soData.soId,val.receivedDate,val.transactionStatus,val.transactionType,val.remarks,createdUser,Number(soData.unitId),CollectionPaymentTypes.EXPORT_RECEIVABLES,val.receivedAmtInr,val.exchangeRate,advance,advance?val.receivedAmt:Number(0),val.receivedBankName)
      service.generatePayment(req).then((res)=>{
        if(res.status){
          AlertMessages.getSuccessMessage(res.internalMessage)
          // console.log('oooooooooooooooooooooooooftrgc');
          form.resetFields()
          setAdvanceMap(new Map())
          setIsModalVisible(false)
          // if (advance ) {
          //   form.setFieldsValue({
          //     paymentType: TransactionPaymentType.Part_Payment,
          //     transactionStatus: TransactionStatus.OPEN,
          //   });
          // }
          getData(tab,advance)
          
        }
      })
    }else if(val.transactionType == TransactionPaymentType.Part_Payment && soData.totalAmount != Number(val.receivedAmt)+Number(val.buyerShortPayment?val.buyerShortPayment:0)+Number(val.bankCharges?val.bankCharges:0)
    ){ 
      console.log(Number(val.receivedAmt)+Number(val.buyerShortPayment?val.buyerShortPayment:0)+Number(val.bankCharges?val.bankCharges:0),'ooooooooo777777777777o888888888888888oo');
      const req= new CollectionsReq(Number(val.bankCharges),soData.buyerId,soData.bankId,val.buyerShortPayment,val.dueDate,soData.eta,soData.etd,soData.totalAmount,soData.invoiceNumber,soData.paymentTermsId,soData.poNum,val.receivedAmt,soData.soId,val.receivedDate,val.transactionStatus,val.transactionType,val.remarks,createdUser,Number(soData.unitId),CollectionPaymentTypes.EXPORT_RECEIVABLES,val.receivedAmtInr,val.exchangeRate,advance,advance?val.receivedAmt:Number(0),val.receivedBankName)
      console.log(req,'reqqqqqqqqqqqqq');
      
      service.generatePayment(req).then((res)=>{
        if(res.status){
          AlertMessages.getSuccessMessage(res.internalMessage)
          // console.log('oooooooooooooooooooooooooftrgc');
          form.resetFields()
          setIsModalVisible(false)
          // if (advance ) {
          //   form.setFieldsValue({
          //     paymentType: TransactionPaymentType.Part_Payment,
          //     transactionStatus: TransactionStatus.OPEN,
          //   });
          // }
          getData(tab,advance)
        }
      })
    }else{
      console.log(Number(val.receivedAmt)+Number(val.buyerShortPayment?val.buyerShortPayment:0)+Number(val.bankCharges?val.bankCharges:0),'oooooooooooo');
      
      if(val.transactionType == TransactionPaymentType.Part_Payment){
        AlertMessages.getErrorMessage(`Part Payment Type Transaction so need to pay Partial amount`)
      }else{
        AlertMessages.getErrorMessage(`Full Payment Type Transaction so need to pay total amount`)
      }
    }
}
else{
  AlertMessages.getErrorMessage(`Sum of buyer short payment and Received amount along with bank charges shouldn't be more than invoice amount`)
}
}
const cancel = () =>{
  setIsModalVisible(false)
  form.resetFields()
}
const onReset = () => {
  form.resetFields();
}
const submit =() =>{
  setTab(form1.getFieldValue('paymentType'))
  if(form1.getFieldValue('paymentType')===CollectionPaymentTypes.EXPORT_RECEIVABLES){
    console.log(form1.getFieldValue('paymentType'),'ppppppp');
    setDdb(false)

  setExportReceivables(true)
  // getData(form1.getFieldValue('paymentType'))
  setRodtep(false)
  setIgst(false)

 }else if(form1.getFieldValue('paymentType')===CollectionPaymentTypes.DUTY_DRAW_BACK){
  setExportReceivables(false)
  setDdb(true)
  setRodtep(false)
  setIgst(false)

  // getData(form1.getFieldValue('paymentType'))

}else if(form1.getFieldValue('paymentType')===CollectionPaymentTypes.RODTEP){
  setExportReceivables(false)
  setDdb(false)
  setRodtep(true)
  setIgst(false)

 }else {
  setExportReceivables(false)
  setDdb(false)
  setRodtep(false)
  setIgst(true)
 }
}
const search =(val) =>{
 getData(tab,advance)
}

const onExchangeRateChange = (e: any) => {
  const exchangeRate = e.target.value;
  const receivedAmount = form.getFieldValue("receivedAmt")


  if (receivedAmount && exchangeRate) {
    const receivedAmtInr = Number(receivedAmount) * parseFloat(exchangeRate);
    form.setFieldsValue({ receivedAmtInr: receivedAmtInr });
  } else {
    form.setFieldsValue({ receivedAmtInr: "" });
  }
};

const onReceivedChange = (e: any) => {
  const receivedAmount = e.target.value;
  const exchangeRate = form.getFieldValue("exchangeRate")
console.log(e.target.value,'ooooooooooo');


  if (receivedAmount && exchangeRate) {
    const receivedAmtInr = Number(receivedAmount) * parseFloat(exchangeRate);
    form.setFieldsValue({ receivedAmtInr: receivedAmtInr.toFixed(2) });
  } else {
    form.setFieldsValue({ receivedAmtInr: "" });
  }
};
const advanceCheck = (val) =>{
  console.log(val,'check');
  if (advance !== val) {
    setAdvance(val);
    setShowFinancialYear(true)
  }
  // setAdvance(val)
  if (val) {
    setShowFinancialYear(false)
    form.setFieldsValue({
      transactionType: TransactionPaymentType.Part_Payment,
      transactionStatus: TransactionStatus.OPEN,
    });
  }
  getData(tab,val)
}
  return (
    <div>
      <Card  size="small" title={<span style={{ color: 'white' }} >Collections</span>}
            style={{ textAlign: 'center' }} headStyle={{ backgroundColor: '#69c0ff', border: 0 }}
            extra={
              <Link to="/collections-grid">
                <Button className="panel_button">View </Button>
              </Link>
            }            >
      <Form form={form1} onFinish={submit}>
      <Row gutter={24}>
    <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 5 }} lg={{ span: 6 }} xl={{ span: 8 }}>
            
      <Form.Item label = 'Payment Type' name='paymentType'>
          <Select
                placeholder="Select Payment Type"
                allowClear
                 >
                {Object.values(CollectionPaymentTypes).map((i) => {
                return (
                  <Option key={i} value={i}>
                    {i}
                  </Option>
                );
              })}

              </Select>
          
          </Form.Item>
          </Col>
          <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 5 }} lg={{ span: 5 }} xl={{ span: 5 }}>
                        <Form.Item >
                            <Button type='primary' htmlType='submit'>Submit</Button>
                        </Form.Item>
                    </Col>
          </Row>
      </Form>
   {exportReceivables?(
     <>
    <>
     
        <Card size="small" title={<span style={{ color: 'white' }} >Export Receivables</span>}
            style={{ textAlign: 'center' }} headStyle={{ backgroundColor: '#69c0ff', border: 0 }}
>
        <Form form={form2} layout='vertical' onFinish={search}>
            <Row gutter={24}>
              {advance!== undefined || null ?(
              <>
                 <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 5 }} lg={{ span: 5 }} xl={{ span: 5 }}>

                        <Form.Item label='Unit' name='unit'>
                          <Select
                            placeholder="Select Unit"
                            allowClear
                            showSearch
                            optionFilterProp="children"
                            filterOption={(input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                            dropdownMatchSelectWidth = {false}
                          >
                         {factoriesData.map(dropData => {
                            console.log(factoriesData,'factoriesDatafactoriesDatafactoriesData')
                            return <Option value={dropData.companyId}>{dropData.company}</Option>
                        })}

                          </Select>

                        </Form.Item>
                      </Col>
              <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 5 }} lg={{ span: 5 }} xl={{ span: 5 }}>

                        <Form.Item label='Buyer' name='buyer'>
                          <Select
                            placeholder="Select buyer"
                            allowClear
                            showSearch
                            optionFilterProp="children"
                            filterOption={(input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                            dropdownMatchSelectWidth = {false}

                          >

                          {buyers
                                .filter(b => b.buyer && b.buyerId !== null) 
                                .map(dropData => (
                                  <Option key={dropData.buyerId} value={dropData.buyerId}>
                                    {dropData.buyer}
                                  </Option>
                          ))}

                          </Select>

                        </Form.Item>
                      </Col>
                      {showFinancialYear && (
                      <Col xs={24} sm={12} md={4} lg={4} xl={4}>
                                    <Form.Item name="financialYear" label="Financial Year">
                                      <Select
                                        showSearch
                                        placeholder="Select Financial Year"
                                        optionFilterProp="children"
                                        allowClear
                                        dropdownMatchSelectWidth = {false}

                                      >
                                        {years.filter(year => year.financialYear !== null).map((y: any) => (
                                          <Select.Option key={y.financialYear} value={y.financialYear}>
                                            {y.financialYear}
                                          </Select.Option>
                                        ))}
                                      </Select>
                                    </Form.Item>
                                  </Col>)}
                                  <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 5 }} lg={{ span: 5 }} xl={{ span: 5 }} style={{ marginTop: '30px' }}>
                            <Form.Item>
                              <Space>
                                <Button type="primary" htmlType="submit">
                                  Search
                                </Button>
                                <Button type="primary" htmlType="reset" onClick={() => onReset()}>
                                  Reset
                                </Button>
                              </Space>
                            </Form.Item>
                          </Col></>
              ):('')}
              <Col style={{marginTop : '30px'}}>
              <Radio.Group 
          value={advance} 
          onChange={(e) => advanceCheck(e.target.value)}
        >
          <Radio value={true}>Advance</Radio>
          <Radio value={false}>Collection</Radio>
        </Radio.Group>
        </Col>
            </Row>
          </Form>
  {data.length > 0 ? (
    <>
          <Table
              size='small'
              columns={columns}
              dataSource={data} />
              </>):('No data found')}
              </Card>
    </>
    <Modal width={'90%'} footer={null} visible={isModalVisible} style={{background:'#69c0ff',textAlign:'center',color:'white'}} title={`Payment Info (Invoice Amount : ${amt?amt:'-'})`}
             onCancel={cancel} >
    <Card >
    <Form form={form} onFinish={save} initialValues={{ transactionType: advance?TransactionPaymentType.Part_Payment:'',transactionStatus:TransactionStatus.OPEN }}>
    <Row gutter={24}>
    <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 5 }} lg={{ span: 6 }} xl={{ span: 8 }}>
            <Form.Item label='Transaction Type' name='transactionType' rules={[{ required: true, message: 'Missing Transaction Type' }]} >
              <Radio.Group onChange={onRadioButtonChange}> 
                    {Object.values(TransactionPaymentType).map((i) => {
                return (
                  <Radio key={i} value={i} disabled={advance} >
                    {i}
                  </Radio>
                );
              })}
                
                </Radio.Group>
            </Form.Item>
          </Col>
          <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 5 }} lg={{ span: 6 }} xl={{ span: 8 }}>
          <Form.Item label='RECEIVED DATE' name='receivedDate'rules={[{ required: true, message: 'Missing Received Date' }]}>
          <DatePicker style={{width:'100%'}}/>
          </Form.Item>
          </Col>
          <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 5 }} lg={{ span: 6 }} xl={{ span: 8 }}>
          <Form.Item label='RECEIVED AMOUNT IN USD' name='receivedAmt' rules={[{ required: true, message: 'Missing Received Amount' }]}>
                <Input placeholder="Enter Amount"  onChange ={onReceivedChange}  />
              </Form.Item>
          </Col>
          
          <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 5 }} lg={{ span: 6 }} xl={{ span: 8 }}>
          <Form.Item label='Exchange Rate' name='exchangeRate' rules={[{ required: true, message: 'Missing Exchange Rate' }]}>
                <Input placeholder="Enter Exchange Rate" onChange={onExchangeRateChange}   />
              </Form.Item>
          </Col>

          <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 5 }} lg={{ span: 6 }} xl={{ span: 8 }}>
          <Form.Item label='RECEIVED AMOUNT IN INR' name='receivedAmtInr'>
                <Input placeholder="Received Amount in INR "  disabled  />
              </Form.Item>
          </Col>
          <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 4 }} lg={{ span: 4 }} xl={{ span: 8 }}>
        <Form.Item name="receivedBankName"   label="Bank Account" rules={[{ required: true,message: 'Missing Bank Account' }]} >
              <Select
                showSearch
                optionFilterProp="children"
                filterOption={(input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                placeholder="Select Bank Account"
                allowClear
                dropdownMatchSelectWidth={false}
              >
                {bankDetails.map(dropData => {
                  return <Option value={`${dropData.bankAcc}-${dropData.bankName}`} key={dropData.id}>{dropData.bankAcc}-{dropData.bankName}</Option>
                })}
              </Select>
            </Form.Item>
          
          </Col>
          <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 5 }} lg={{ span: 6 }} xl={{ span: 8 }}>
          <Form.Item label=' BANK CHARGES ' name='bankCharges'>
                <Input placeholder="Enter charges"  />
              </Form.Item>
          </Col>
          <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 5 }} lg={{ span: 6 }} xl={{ span: 8 }}>
          <Form.Item label=' BUYER SHORT PAYMENT ' name='buyerShortPayment'>
                <Input placeholder="Enter Short Payment"  />
              </Form.Item>
          </Col>
          <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 5 }} lg={{ span: 6 }} xl={{ span: 8 }}>
          <Form.Item label='REMARKS' name='remarks'>
            <TextArea/>
          </Form.Item>
          </Col>
          <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 5 }} lg={{ span: 6 }} xl={{ span: 8 }}>
          <Form.Item label = 'TRANSACTION STATUS' name='transactionStatus' rules={[{ required: true, message: 'Transaction status' }]}>
          <Select
                placeholder="Select Transaction Status"
                allowClear
                // onChange={vehicleChange}
              disabled={true}
              >
                {Object.values(TransactionStatus).map((i) => {
                return (
                  <Option key={i} value={i}>
                    {i}
                  </Option>
                );
              })}

              </Select>
          
          </Form.Item>
          </Col>
                    </Row>
                    <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 5 }} lg={{ span: 5 }} xl={{ span: 5 }}>
                        <Form.Item >
                            <Button type='primary' htmlType='submit'>Save</Button>
                        </Form.Item>
                    </Col>
                </Form>
                </Card>
        {/* <ContainerCapturingAgainstEnquiry productsInfo={productDetails} pageName="CostSheet" acceptButton={acceptButton} enquiryId={props.enquiryId} closeModal={closeApproveModal} /> */}
      </Modal>
      </>
      ):''}
      {ddb?(
        <DDBCollections tab={tab}/>
      ):''}
      {rodtep?(
        <Rodtep tab={tab}/>
      ):''}
      {igst?(
        <IgstCollections tab={tab}/>
      ):''}
      </Card>
      </div>
  );
}

export default Collections;
